import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

export default function SearchTitle({ searchState }) {
  const query = searchState.query;
  return (
    <h1 className="mb-0">
      <FormattedMessage id="search-title.no-results" defaultMessage="Search Results" />
      {query &&
        <span> - {query}</span>
      }
    </h1>
  );
}

SearchTitle.propTypes = {
  searchState: PropTypes.shape({}).isRequired,
};
